import React from 'react';
import { Box, Typography } from '@mui/material';

const FlowIdLabel = ({ id, externalId }) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: '40px', marginRight: '16px', flexShrink: 0 }}>
        <Typography variant="body2" sx={{ color: '#666', fontSize: '0.75rem', fontWeight: 500 }}>
            {id}
        </Typography>
        {externalId && (
            <Typography variant="body2" sx={{ color: '#666', fontSize: '0.7rem', whiteSpace: 'nowrap' }}>
                {externalId}
            </Typography>
        )}
    </Box>
);

export default FlowIdLabel;
